import React from "react";

export default class Cookies extends React.Component {
    render() {
        return(
            <div>Cookies</div>
        )
    };
}